import * as Yup from 'yup';
import { STUDENT_ROLE_ID } from 'constants/roles';

export const CandidateRegistrationFormValidationSchema = [
  // Step 1
  Yup.object().shape({
    bs: Yup.array()
      .nullable()
      .required('This field is required'),

    fs: Yup.array()
      .nullable()
      .required('This field is required'),

    loc: Yup.array()
      .nullable()
      .required('This field is required'),

    manageAccount: Yup.string()
      .nullable()
      .required('This field is required'),

    openOp: Yup.string()
      .nullable()
      .required('This field is required'),

    citizenship: Yup.array()
      .nullable()
      .required('Citizenship field is required'),

    lang: Yup.array()
      .nullable()
      .test(
        'check-Languages',
        'Please select Language and Level',
        value => value && !value.some(v => !v.language || !v.level)
      )
      .test(
        'unique-Languages',
        'Please remove duplicates',
        value =>
          value &&
          !value.some(
            v =>
              v.language &&
              value.find(c => c !== v && c.language === v.language)
          )
      ),
  }),

  // Step 2
  Yup.object().shape({
    role: Yup.object()
      .nullable()
      .required('This field is required'),

    title: Yup.object()
      .nullable()
      .when(['role'], (role, schema) =>
        !role || Number(role.value) !== STUDENT_ROLE_ID
          ? schema.required('This field is required')
          : schema
      ),

    degree: Yup.object()
      .nullable()
      .when(['role'], (role, schema) =>
        role && Number(role.value) === STUDENT_ROLE_ID
          ? schema.required('This field is required')
          : schema
      ),

    school: Yup.object()
      .nullable()
      .required('This field is required'),

    startDate: Yup.object()
      .nullable()
      .test(
        'is-valid-date',
        'This field is required',
        value => value && value.year && value.month
      ),

    graduationYear: Yup.object()
      .nullable()
      .required('This field is required'),

    major: Yup.string()
      .nullable()
      .required('This field is required')
      .max(255, 'You have exceeded the maximum number of 255 characters'),

    gpa: Yup.object()
      .nullable()
      .required('This field is required'),

    mathSat: Yup.object()
      .nullable()
      .required('This field is required'),

    verbalSat: Yup.object()
      .nullable()
      .required('This field is required'),

    writingSat: Yup.object()
      .nullable()
      .required('This field is required'),

    actScore: Yup.object()
      .nullable()
      .required('This field is required'),

    gmat: Yup.object()
      .nullable()
      .required('This field is required'),

    currentFirm: Yup.object()
      .nullable()
      .when(['role'], (role, schema) =>
        !role || Number(role.value) !== STUDENT_ROLE_ID
          ? schema.required('This field is required')
          : schema
      ),

    currentSchool: Yup.object()
      .nullable()
      .when(['role'], (role, schema) =>
        role && Number(role.value) === STUDENT_ROLE_ID
          ? schema.required('This field is required')
          : schema
      ),

    group: Yup.array()
      .nullable()
      .when(['role'], (role, schema) =>
        !role || Number(role.value) !== STUDENT_ROLE_ID
          ? schema.required('This field is required')
          : schema
      ),

    industry: Yup.array()
      .nullable()
      .when(['role'], (role, schema) =>
        !role ||
        (Number(role.value) !== STUDENT_ROLE_ID && !role.attrs.HideIndustry)
          ? schema.required('This field is required')
          : schema
      ),

    officeLoc: Yup.object()
      .nullable()
      .required('This field is required'),
  }),

  // Step 3
  Yup.object().shape({
    resume: Yup.mixed()
      .nullable()
      .test(
        'is-valid-resume-format',
        'This type of file is not supported',
        value =>
          value
            ? new RegExp(/\.(doc|docx|pdf|odt|rtf)$/i).test(value.name)
            : true
      )
      .test(
        'is-valid-resume-size',
        'The file is too big. Max file size is 2MB',
        value => (value ? value.size <= 2 * 1024 * 1024 : true)
      ),
  }),

  // Step 4
  Yup.object().shape({
    workEmail: Yup.string()
      .nullable()
      .email('Email address is incorrect')
      .max(100, 'You have exceeded the maximum number of 100 characters'),

    email2: Yup.string()
      .nullable()
      .email('Email address is incorrect')
      .max(100, 'You have exceeded the maximum number of 100 characters'),

    phone: Yup.string()
      .nullable()
      .required('This field is required')
      .matches(/^[+\-()\s\d]+$/, {
        message: 'Phone number is wrong',
        excludeEmptyString: false,
      })
      .max(30, 'You have exceeded the maximum number of 30 characters'),

    phone2: Yup.string()
      .nullable()
      .matches(/^[+\-()\s\d]+$/, {
        message: 'Phone number is wrong',
        excludeEmptyString: true,
      })
      .max(30, 'You have exceeded the maximum number of 30 characters'),
  }),
];

export default CandidateRegistrationFormValidationSchema;
